document.addEventListener("DOMContentLoaded", () => {

  // Detect clicks on any "Quick add" button
  document.body.addEventListener("click", (e) => {
    const btn = e.target.closest("[data-quick-add-btn]");
    if (!btn) return;

    // Observe for drawer injection
    const observer = new MutationObserver(() => {
      const drawer = document.querySelector("dialog.product-quick-add[open]");
      if (!drawer) return;

      // Run Zenoti watcher inside drawer
      initZenotiWatcher(drawer);
      observer.disconnect();
    });

    observer.observe(document.body, { childList: true, subtree: true });
  });

  // Function that runs inside the drawer
  function initZenotiWatcher(context) {
    const variantInput = context.querySelector('input[name="id"]');
    if (!variantInput) return;

    const zenotiButton = context.querySelector("a.zenoti_btn");
    if (!zenotiButton) return;

    // Load Zenoti links from data attribute
    const linksScript = context.querySelector('[data-variant-zenoti-links]');
    const variantLinks = linksScript ? JSON.parse(linksScript.textContent) : {};

    const updateZenotiButton = () => {
      const selectedVariantId = variantInput.value;
      const link = variantLinks[selectedVariantId] || '/default-product-link';
      zenotiButton.href = link;
    };

    // Initial update
    updateZenotiButton();

    // Listen for variant changes
    variantInput.addEventListener("change", updateZenotiButton);
  }
});